<div class="stockdetailwrapper"> 
    
    <div class="stockdetail text-heading-3" *ngIf="storeName" (click)="goBack()">
        <img src="../../../../assets/images/storelist/backarrow.svg">Stocks at {{ storeName }} 
    </div> 
  
   <div class="storedetailwrapper">
    
    <ng-container *ngFor="let stock of stocks; let i = index"> 
      <a [routerLink]="stock.navigate">
      <div class="storewrapper"> 
        <div class="hrline"><hr /></div>
        <img class="stockimg" [src]="imagePaths[i]" alt="implants"> 
        <div> 
          <div class="stockslist"> 
            <div class="stocksname text-para">{{ stock.name }}</div> 
          </div> 
          <div class="stocksection"> 
            <div *ngIf="stockDetails && stockDetails[stockNames[i]] !== undefined" class="stockcount">
              <div class="stock-value text-heading-3">{{ stockDetails[stockNames[i]] }}</div>
            </div>
            <div class="downloadimg">
              <div class="downloadcontent text-button">View
                <!-- <img class="downloadimgcontent" src="../../../../assets/images/storelist/download.svg" alt="download"> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
    </ng-container> 
 
   </div>  

   <div class="d-flex w-100 gap-3 mt-3">
      <div class="w-50 app-border-grey p-3">
        <h4 class="text-heading-4 text-dark mb-4">Consumption Summary</h4>
        <app-consumption-summary></app-consumption-summary>
      </div>
      <div class="w-50 app-border-grey p-3">
        <h4 class="text-heading-4 text-dark mb-4">Most consumed Products</h4>
        <app-consumed-products></app-consumed-products>
      </div>
   </div>
</div>